<div class="if-frame">
  @if (onCover) {
    <!-- Cover. Every waiting item on screen before any paging is required — a queue
         discoverable only by pressing › is, in practice, a queue of one. -->
    <header class="if-head">
      <h2 #heading class="if-title" tabindex="-1" id="interrupt-frame-title">
        {{ 'postLoginInterrupts.frame.heading' | translate: { count: items.length } }}
      </h2>
      @if (!mandatoryGate) {
        <button
          type="button"
          class="if-icon"
          [attr.aria-label]="'postLoginInterrupts.frame.close' | translate"
          (click)="close()"
        >
          &times;
        </button>
      }
    </header>

    <div class="if-scroll">
      <p class="if-cover-sub">{{ 'postLoginInterrupts.frame.subheading' | translate }}</p>

      <ul class="if-cover-list">
        @for (item of items; track item.key; let i = $index) {
          <li>
            <button
              type="button"
              class="if-cover-row"
              [class.is-gate]="item.kind === 'gate'"
              (click)="goTo(i)"
            >
              <span class="if-cover-marker" aria-hidden="true"></span>
              <span class="if-cover-text">
                <span class="if-cover-label-line">
                  <span class="if-cover-label">{{ item.label }}</span>
                  @if (item.kind === 'gate') {
                    <span class="if-chip">{{
                      'postLoginInterrupts.frame.required' | translate
                    }}</span>
                  }
                </span>
                @if (item.summary) {
                  <span class="if-cover-summary">{{ item.summary }}</span>
                }
              </span>
              <span class="if-cover-go" aria-hidden="true">&rsaquo;</span>
            </button>
          </li>
        }
      </ul>
    </div>

    <footer class="if-foot">
      <button type="button" class="btn btn-primary if-cta" (click)="goTo(0)">
        {{ 'postLoginInterrupts.frame.start' | translate }}
      </button>
    </footer>
  } @else {
    <!-- One card. Three controls in the header and never more: the paging moved to the
         footer beside the dots so the title stops truncating at 375px. -->
    <header class="if-head">
      <button type="button" class="if-back" (click)="backToCover()">
        <span aria-hidden="true">&lsaquo;</span>
        {{ 'postLoginInterrupts.frame.all' | translate }}
        <span class="if-back-count">{{ items.length }}</span>
      </button>
      <h2 #heading class="if-title if-title--card" tabindex="-1" id="interrupt-frame-title">
        {{ active.label }}
      </h2>
      @if (!mandatoryGate) {
        <button
          type="button"
          class="if-icon"
          [attr.aria-label]="'postLoginInterrupts.frame.close' | translate"
          (click)="close()"
        >
          &times;
        </button>
      }
    </header>

    <div #cardRegion class="if-scroll if-scroll--card" [style.min-height.px]="cardFloor">
      <ng-container *ngComponentOutlet="active.component; inputs: inputsFor(active)"></ng-container>
    </div>

    <footer class="if-foot if-foot--pager">
      <div class="if-pager">
        <button
          type="button"
          class="if-pg-nav"
          [attr.aria-label]="'postLoginInterrupts.frame.previous' | translate"
          (click)="page(-1)"
        >
          &lsaquo;
        </button>
        <span class="if-pg-count">{{
          'postLoginInterrupts.frame.position'
            | translate: { current: index + 1, total: items.length }
        }}</span>
        <span class="if-pg-dots">
          @for (item of items; track item.key; let i = $index) {
            <button
              type="button"
              class="if-dot"
              [class.is-active]="i === index"
              [class.is-gate]="item.kind === 'gate'"
              [attr.aria-current]="i === index ? 'true' : null"
              [attr.aria-label]="
                'postLoginInterrupts.frame.itemLabel'
                  | translate: { label: item.label, current: i + 1, total: items.length }
              "
              (click)="goTo(i)"
            ></button>
          }
        </span>
        <button
          type="button"
          class="if-pg-nav"
          [attr.aria-label]="'postLoginInterrupts.frame.next' | translate"
          (click)="page(1)"
        >
          &rsaquo;
        </button>
      </div>

      <!-- Present on EVERY card view while a gate is queued, wording adapted to whether
           the gate is the card on screen. Without it, "paged past re-KYC" is exactly the
           state with no gate signal anywhere — and a note that appeared on only some
           pages would itself resize the frame on every ‹ ›. -->
      @if (gate) {
        <p class="if-gate-note">
          @if (gate === active) {
            <span>{{ 'postLoginInterrupts.frame.gateNoteHere' | translate }}</span>
          } @else {
            <span
              [innerHTML]="
                'postLoginInterrupts.frame.gateNoteElsewhere'
                  | translate: { label: escapedGateLabel }
              "
            ></span>
          }
        </p>
      }
    </footer>
  }
</div>
